import React, { FC } from "react";

import CloseButton from "./closeButton";
import ScanSwitch from "./scanSwitch";
import CameraButton from "../assets/camera_button.png";

import { useGlobalContext } from "./ScanViewerContext";

import styles from "./cardCapture.module.scss";

type Props = {
  children: React.ReactNode;
};

const CardCapture: FC<Props> = ({ children }) => {
  const {
    showCurtain,
    onCloseBtn,
    closeButton,
    isMobileOnLandscape,
    stateMachineState,
    stateMachineSend,
    isMobile,
  } = useGlobalContext();

  const isPending = ["cameraLoading", "autoCapture", "manualCapture"].some(
    stateMachineState.matches
  );

  const showCameraButton =
    (!stateMachineState.context.autoScan &&
      !stateMachineState.context.processing) ||
    (stateMachineState.context.autoScan &&
      stateMachineState.context.showCameraButton &&
      !stateMachineState.context.processing);

  return (
    <>
      {!showCurtain && (
        <CloseButton onCloseBtn={onCloseBtn} closeButton={closeButton} />
      )}
      {showCurtain && (
        <div
          className={`${styles.topCurtain} ${
            isMobileOnLandscape && styles.topCurtainLandscape
          }`}
          id="mobileTopCurtain"
        >
          {showCurtain && (
            <CloseButton onCloseBtn={onCloseBtn} closeButton={closeButton} />
          )}
          {showCurtain && !stateMachineState.context.processing && (
            <ScanSwitch isMobile={showCurtain} />
          )}
        </div>
      )}
      {children}
      {showCurtain && (
        <div
          id="mobileBottomCurtain"
          className={
            isMobileOnLandscape
              ? styles.bottomCurtainLandscape
              : styles.bottomCurtain
          }
          style={{
            display: showCurtain ? "block" : "none",
          }}
        >
          {showCameraButton && (
            <button
              data-cy="cameraBtn"
              className={`${styles.cameraBtn} ${isMobile ? styles.mobile : ""}`}
              style={{ display: showCameraButton ? "block" : "none" }}
              id="camera-btn"
              onClick={() => stateMachineSend("MANUAL_BUTTON_CLICK")}
              aria-label="Camera"
            >
              <img
                src={CameraButton}
                alt="Take photo of insurance card"
                draggable={false}
              />
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default CardCapture;
